function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "Path_360",
  "data-name": "Path 360",
  d: "M36.3,23.53a1.925,1.925,0,0,1-1.925-1.925V10.057a3.212,3.212,0,0,0-3.208-3.208H11.925a1.925,1.925,0,1,1,0-3.849H31.172a7.063,7.063,0,0,1,7.057,7.057V21.605A1.925,1.925,0,0,1,36.3,23.53Z",
  transform: "translate(15.662 4.699)",
  fill: "#ac1ede"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "Path_361",
  "data-name": "Path 361",
  d: "M24.165,16.09a1.91,1.91,0,0,1-1.36-.565l-4.491-4.491a1.924,1.924,0,0,1,1.36-3.285h8.982a1.924,1.924,0,0,1,1.36,3.285l-4.491,4.491A1.909,1.909,0,0,1,24.165,16.09Z",
  transform: "translate(27.801 12.138)",
  fill: "#ac1ede"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  id: "Path_362",
  "data-name": "Path 362",
  d: "M24.172,33.53H10.057A7.063,7.063,0,0,1,3,26.473V14.925a1.925,1.925,0,1,1,3.849,0V26.473a3.212,3.212,0,0,0,3.208,3.208H24.172a1.925,1.925,0,1,1,0,3.849Z",
  transform: "translate(4.699 20.361)",
  fill: "#ac1ede"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  id: "Path_363",
  "data-name": "Path 363",
  d: "M12.157,21.34H3.175a1.924,1.924,0,0,1-1.36-3.285l4.491-4.491a1.925,1.925,0,0,1,2.723,0l4.491,4.491a1.924,1.924,0,0,1-1.363,3.285Z",
  transform: "translate(1.958 20.362)",
  fill: "#ac1ede"
});

var _ref6 = /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_95",
  "data-name": "Ellipse 95",
  cx: 6.416,
  cy: 6.416,
  r: 6.416,
  transform: "translate(6.416)",
  fill: "#ac1ede"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  id: "Path_364",
  "data-name": "Path 364",
  d: "M18.605,6H7.057A7.063,7.063,0,0,0,0,13.057V14.34a1.925,1.925,0,0,0,1.925,1.925H23.738a1.925,1.925,0,0,0,1.925-1.925V13.057A7.063,7.063,0,0,0,18.605,6Z",
  transform: "translate(0 9.397)",
  fill: "#ac1ede"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  id: "Path_365",
  "data-name": "Path 365",
  d: "M22.916,26.831a6.416,6.416,0,1,1,6.416-6.416A6.425,6.425,0,0,1,22.916,26.831Z",
  transform: "translate(25.843 21.927)",
  fill: "#ac1ede"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  id: "Path_366",
  "data-name": "Path 366",
  d: "M37.738,30.265H15.925A1.925,1.925,0,0,1,14,28.34V27.057A7.063,7.063,0,0,1,21.057,20H32.605a7.063,7.063,0,0,1,7.057,7.057V28.34A1.925,1.925,0,0,1,37.738,30.265Z",
  transform: "translate(21.927 31.325)",
  fill: "#ac1ede"
});

var SvgTransferUsers = function SvgTransferUsers(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "transfer",
    width: 61.59,
    height: 61.59,
    viewBox: "0 0 61.59 61.59",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTransferUsers, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/transferUsers.2edfceb7.svg";
export { ForwardRef as ReactComponent };